export const AUTH_STORAGE_CONSTANTS = {
  IS_STAFF: "is_staff",
  BD_LOGIN: "bdLogin",
  BD_EMAIL: "bdEmail",
  USER_IDENTITY: "user_identity",
  UUID: "uuid",
};
